import { Box, Button, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ShareHeaderProps {
  setIsOpen: (value: boolean) => void;
  title: string;
}

export const ShareHeader = (props: ShareHeaderProps) => {
  const { setIsOpen, title } = props;

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Box className="header">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          variant="transparent"
          onClick={() => onClose()}
          sx={{ color: 'white' }}
        >
          <CloseIcon />
        </Button>
      </Box>

      <DialogTitle
        sx={{ padding: '12px', fontSize: '45px', textAlign: 'center' }}
        id="share-dialog-title"
      >
        {title}
      </DialogTitle>
    </Box>
  );
};
